import React from 'react';
import { Link } from 'react-router-dom';  // Import Link from react-router-dom
import { FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import './Footer.css'; // Import the corresponding CSS file

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column">
          <h3>Chennai Home Appliance Care</h3>
          <p>We provide expert home appliance repair services in Chennai, specializing in washing machines and fridges. Our technicians offer quick, reliable, and affordable repairs with a customer-first approach.</p>
        </div>

        <div className="footer-column">
          <h3>Our Services</h3>
          <ul>
            <li><Link to="/washing-machine-service">Washing Machine Repair</Link></li> {/* Updated with Link */}
            <li><Link to="/fridge-service">Fridge Repair</Link></li> {/* Updated with Link */}
          </ul>
          
        </div>
        

        <div className="footer-column">
          <h3>Contact Us</h3>
          <p>Address: No.73A Bajanai Koil Street Thiruvalluvar Nagar Pammal Chennai -
          600075</p>
          <p>Phone: <a href="tel:+918270096596">+91 82700 96596</a></p>
          <p>Email: <a href="mailto:chennaihomeappliancecare@gmail.com">chennaihomeappliancecare@gmail.com</a></p>
         

          <div className="social-icons">
            <a href="https://wa.me/+918270096596" target="_blank" rel="noopener noreferrer" className="social-icon">
              <FaWhatsapp size={40} />
            </a>
            <a 
        href="mailto:chennaihomeappliancecare@gmail.com" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="social-icon"
      >
        <FaEnvelope size={40} />
      </a>

          </div>
        </div>
      </div>
      <div className="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d497511.23105803586!2d79.87932965728102!3d13.047985947000162!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5265ea4f7d3361%3A0x6e61a70b6863d433!2sChennai%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1730962055463!5m2!1sen!2sin"
          width="100%" height="400" style={{ border: '0' }} allowFullScreen="" loading="lazy" title="Google Maps Location of Chennai, Tamil Nadu" />
      </div>

      {/* Added Sections for Legal Notices */}
      <div className="legal-notices">
        <div className="legal-column">
          <h3>Privacy Policy</h3>
          <Link to="/privacy-policy" className="legal-link">Read our Privacy Policy</Link> {/* Updated with Link */}
        </div>
        <div className="disclaimer-section">
      <div className="disclaimer-container">
        <h3 className="disclaimer-title">Disclaimer:</h3>
        <p className="disclaimer-text">
          <strong> "NANDHINI INDRAJITH" is Advertiser For  Chennai Home Appliance Care</strong> is an independent service provider and is not affiliated with or authorized by any specific brand or manufacturer. We offer repair and maintenance services for a wide range of home appliances across multiple brands.
        </p> 
      </div>
    </div>

        <div className="legal-column">
          <h3>Terms & Conditions</h3>
          <Link to="/terms-and-conditions" className="legal-link">View Terms & Conditions</Link> {/* Updated with Link */}
        </div>
      </div>


    </footer>
  );
};

export default Footer;
